import React from 'react'
import PropTypes from 'prop-types'
import { EditTeamsForm } from 'local/components'

const TeamsAddComponent = ({ onSubmit }) => (
  <EditTeamsForm header="Add Team" onSubmit={onSubmit} initialValues={{}} />
)

TeamsAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default TeamsAddComponent
